export const prompts = [
  "does Racism",
  "do Clouds",
  "do Flowers",
  "does War",
  "does Music",
  "does Time",
  "does Love",
  "does Tea",
  "does Flight",
  "does Abstract Art",
];
